export default __webpack_public_path__ + "static/media/Trello.5e6edb73.svg";